import { MatchField, PaymentCard } from '@mews-commander/guest-profile';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedWallClockDate, WallClockDateService } from '@mews/framework';
import { Optional } from '@mews/std';
import { Typography } from '@optimus-web/core';
import PaymentCardIcon from '../../../../../../../../components/commander-ui/PaymentCardIcon';

const isPaymentCard = (value: string | PaymentCard): value is PaymentCard =>
    typeof value === 'object' && 'lastDigits' in value && 'type' in value;

export const FieldValue = ({ type, value }: { type: MatchField; value: Optional<string> | PaymentCard }) => {
    if (!value) return null;

    if (type === MatchField.BirthDate && typeof value === 'string') {
        return (
            <Typography textStyle="bodyMedium" variant="secondary" align="center" as="div">
                <LocalizedWallClockDate wallClockDate={WallClockDateService.parse(value)} />
            </Typography>
        );
    }

    if (type === MatchField.PaymentCard && isPaymentCard(value)) {
        const { lastDigits, type: typeCard } = value;
        return (
            <Typography textStyle="bodyMedium" variant="secondary" align="center" as="div">
                <PaymentCardIcon type={typeCard} width={24} />
                {UnicodeEntity.NoBreakSpace}
                {lastDigits}
            </Typography>
        );
    }
    return (
        <Typography textStyle="bodyMedium" variant="secondary" align="center" wordBreak="break-word" as="div">
            {!isPaymentCard(value) ? value : '-'}
        </Typography>
    );
};
